(function () {
  const CERT_IDS = [53328477946170, 53170058625338, 53253208146234];

  const drawer = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartDrawerOverlay');
  const body = document.getElementById('cartDrawerBody');
  const floatingBtn = document.getElementById('floatingCartBtn');

  if (!drawer || !overlay || !body || !floatingBtn) return;

  floatingBtn.innerHTML = `
    <svg class="floating-cart__icon" width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M6.5 6.5h14l-1.5 8.5H8.2L6.5 6.5Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
      <path d="M6.5 6.5 5.8 3.8H3.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
      <circle cx="9" cy="19" r="1.5" stroke="currentColor" stroke-width="1.7"/>
      <circle cx="18" cy="19" r="1.5" stroke="currentColor" stroke-width="1.7"/>
    </svg>
    <span id="floatingCartBadge" class="floating-cart__badge" hidden>0</span>
  `;
  const floatingBadge = document.getElementById('floatingCartBadge');

  function setChatVisibility(hidden) {
    const selectors = [
      '#shopify-chat',
      'inbox-online-store-chat',
      'iframe#smile-lite-launcher-frame',
      '.smile-launcher-frame-container',
      '[class*="smile" i]',
      '[id*="smile" i]'
    ];
    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        if (hidden) {
          el.dataset.prevDisplay = el.style.display || '';
          el.style.display = 'none';
        } else {
          el.style.display = el.dataset.prevDisplay || '';
        }
      });
    });
  }

  function openDrawer() {
    overlay.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    setChatVisibility(true);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    setChatVisibility(false);
  }

  overlay.addEventListener('click', closeDrawer);
  drawer.querySelector('.cart-drawer__close')?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return await res.json();
  }

  function updateFloatingBadge(itemCount) {
    if (!floatingBadge) return;
    floatingBadge.textContent = String(itemCount || 0);
    floatingBadge.hidden = !(itemCount > 0);
  }

  async function renderCart() {
    const cart = await fetchCart();
    updateFloatingBadge(cart.item_count);

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = `<p>Your cart is empty.</p>`;
      return;
    }

    const FREE_SHIP_CENTS = 29900;
    const subtotal = cart.total_price;
    const remaining = Math.max(0, FREE_SHIP_CENTS - subtotal);
    const pct = Math.min(100, Math.round((subtotal / FREE_SHIP_CENTS) * 100));

    const shippingMsg = remaining === 0
      ? `🎉 You've qualified for FREE shipping!`
      : `✨ You're only <strong>$${(remaining/100).toFixed(0)}</strong> away from Free Shipping!`;

    let upsellHtml = '';
    if (remaining > 0) {
      try {
        const baseProductId = cart.items?.[0]?.product_id;
        if (!baseProductId) throw new Error('No base product_id in cart');

        const recRes = await fetch(
          `/recommendations/products.json?product_id=${baseProductId}&limit=12&intent=related`,
          { credentials: 'same-origin' }
        );
        if (!recRes.ok) throw new Error('recommendations fetch failed');
        const recJson = await recRes.json();
        const recs = recJson?.products || [];

        const picks = recs
          .filter(p => p?.available && p?.variants?.length)
          .map(p => {
            const v = p.variants[0];
            const priceCents = Number(v.price);
            const diff = Math.abs(remaining - priceCents);
            return { p, v, priceCents, diff };
          })
          .filter(x => Number.isFinite(x.priceCents) && x.priceCents > 0)
          .sort((a, b) => a.diff - b.diff)
          .slice(0, 2);

        if (picks.length) {
          upsellHtml = `
            <div class="cd-upsell">
              <div class="cd-upsell__title">Top picks to reach FREE shipping</div>
              <div class="cd-upsell__grid cd-upsell__grid--two">
                ${picks.map(({ p, v, priceCents }) => {
                  const titleShort = (p.title || '').trim().slice(0, 36) + ((p.title || '').length > 36 ? '…' : '');
                  return `
                    <button class="cd-upsell__card" type="button" data-variant-id="${v.id}">
                      <img class="cd-upsell__img" src="${p.featured_image || ''}" alt="">
                      <div class="cd-upsell__name">${titleShort}</div>
                      <div class="cd-upsell__price">$${(priceCents/100).toFixed(2)}</div>
                      <div class="cd-upsell__unlock">Unlocks FREE shipping</div>
                      <div class="cd-upsell__add">Add</div>
                    </button>
                  `;
                }).join('')}
              </div>
            </div>
          `;
        }
      } catch (err) {
        console.warn('Upsell error:', err);
        upsellHtml = '';
      }
    }

    // ✅ 用 item.key 而不是 idx+1，避免 line number 對不上
    const itemsHtml = cart.items.map((item) => {
      const isCert = CERT_IDS.includes(item.variant_id);

      const qtyControls = isCert
  ? `<span class="cd-item__cert-lock" style="font-size:12px;opacity:0.6;">Included with product (qty: ${item.quantity})</span>
     <button class="remove-btn" data-key="${item.key}">Remove</button>`
  : `<button class="qty-btn" data-key="${item.key}" data-delta="-1" aria-label="Decrease">−</button>
     <span class="qty-val">${item.quantity}</span>
     <button class="qty-btn" data-key="${item.key}" data-delta="1" aria-label="Increase">+</button>
     <button class="remove-btn" data-key="${item.key}">Remove</button>`;

      return `
        <div class="cd-item">
          <img class="cd-item__img" src="${item.image || ''}" alt="">
          <div class="cd-item__meta">
            <div class="cd-item__title">${item.product_title}</div>
            <div class="cd-item__row">
              ${qtyControls}
            </div>
            <div class="cd-item__price">$${(item.final_line_price/100).toFixed(2)}</div>
          </div>
        </div>
      `;
    }).join('');

    const subtotalHtml = `
      <div class="cd-summary">
        <div class="cd-summary__row">
          <span>Subtotal</span>
          <strong>$${(subtotal/100).toFixed(2)}</strong>
        </div>
      </div>
    `;

    const qualified = remaining === 0;
    const shipHtml = `
      <div class="cd-ship ${qualified ? 'is-qualified' : ''}">
        <div class="cd-ship__msg">${shippingMsg}</div>
        <div class="cd-ship__bar">
          <div class="cd-ship__fill" style="width:${pct}%"></div>
        </div>
      </div>
    `;

    const actionsHtml = `
      <div class="cd-actions">
        <button type="button" class="cd-btn cd-btn--primary cart-drawer__keep">Keep shopping</button>
        <a class="cd-btn cd-btn--dark" href="/checkout">Checkout</a>
      </div>
      <div class="cd-secure">🔒 Secure checkout · Ships from Canada</div>
    `;

    body.innerHTML = itemsHtml + subtotalHtml + shipHtml + upsellHtml + actionsHtml;

    body.querySelector('.cart-drawer__keep')?.addEventListener('click', closeDrawer);

    body.querySelectorAll('.cd-upsell__card').forEach(card => {
      card.addEventListener('click', async () => {
        const variantId = card.getAttribute('data-variant-id');
        if (!variantId) return;
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });
        await renderCart();
      });
    });
  }

  // ✅ 用 item.key 精確定位，不用 line number
  async function changeItemQty(key, newQty) {
    const cart = await fetchCart();
    const item = cart.items.find(i => i.key === key);
    if (!item) return;

    // 🔒 證書不能單獨調整數量，只能刪除
    if (CERT_IDS.includes(item.variant_id)) {
      if (newQty !== 0) return;
    }

    // 執行數量變更
await fetch('/cart/change.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
  body: JSON.stringify({ id: key, quantity: newQty }),
  credentials: 'same-origin'
});

// 非證書產品：同步對應的證書數量
if (!CERT_IDS.includes(item.variant_id)) {
  const groupId = item.properties && item.properties['_group'];
  if (groupId) {
    // 重新 fetch 拿 Shopify 實際調整後的數量
    const updatedCart = await fetchCart();
    const actualItem = updatedCart.items.find(i => i.key === key);
    const actualQty = actualItem ? actualItem.quantity : newQty;

    for (const certItem of updatedCart.items) {
      if (
        CERT_IDS.includes(certItem.variant_id) &&
        certItem.properties &&
        certItem.properties['_group'] === groupId
      ) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: certItem.key, quantity: actualQty }),
          credentials: 'same-origin'
        });
      }
    }
  }
}

    // 最終對齊：確保所有產品的 cert 數量都跟產品一致
    const finalCart = await fetchCart();
    for (const finalItem of finalCart.items) {
      if (CERT_IDS.includes(finalItem.variant_id)) continue;
      const finalGroup = finalItem.properties && finalItem.properties['_group'];
      if (!finalGroup) continue;

      const finalCert = finalCart.items.find(ci =>
        CERT_IDS.includes(ci.variant_id) &&
        ci.properties &&
        ci.properties['_group'] === finalGroup
      );

      if (finalCert && finalCert.quantity !== finalItem.quantity) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: finalCert.key, quantity: finalItem.quantity }),
          credentials: 'same-origin'
        });
      }
    }

    await renderCart();
  }

  // ✅ 暴露給 product template cert script 使用
  window.__cartDrawerRender = renderCart;
  window.__cartDrawerOpen = openDrawer;

  floatingBtn.addEventListener('click', async () => {
    await renderCart();
    openDrawer();
  });

  drawer.addEventListener('click', async (e) => {
    const qtyBtn = e.target.closest('.qty-btn');
    if (qtyBtn) {
      const key = qtyBtn.dataset.key;
      const delta = Number(qtyBtn.dataset.delta);
      const qtySpan = qtyBtn.parentElement.querySelector('.qty-val');
      const currentQty = Number(qtySpan?.textContent || 1);
      const nextQty = Math.max(0, currentQty + delta);
      await changeItemQty(key, nextQty);
      return;
    }

    const removeBtn = e.target.closest('.remove-btn');
    if (removeBtn) {
      const key = removeBtn.dataset.key;
      await changeItemQty(key, 0);
      return;
    }
  });

  // ✅ 產品頁 Add to Cart 由 cert script 處理，這裡只負責攔截不讓瀏覽器原生 submit
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = (form.getAttribute('action') || '').toLowerCase();
    if (!action.includes('/cart/add')) return;

    if (form.querySelector('button[name="add"]')) {
      // 產品頁表單：cert script 會處理，這裡只阻止瀏覽器原生行為
      e.preventDefault();
      return;
    }

    // 其他表單正常處理
    e.preventDefault();
    const formData = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData,
      credentials: 'same-origin'
    });

    if (!res.ok) {
      window.location.href = '/cart';
      return;
    }

    await renderCart();
    openDrawer();
  }, true);

  renderCart().catch(() => {});
})();